import { ASQ_SURVEYS_CSV_REPORT_RECEIVE } from 'actions/asq';

const defaultState = {};

export default function asqSurveysCSVReport(state = defaultState, action) {
  switch (action.type) {
    case ASQ_SURVEYS_CSV_REPORT_RECEIVE:
      return action.payload;
    default:
      return state;
  }
}
